import { URI_FINANCIAL_ACCOUNT } from '@/config/config';

export default async ({ rootState }, labelId) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await fetch(
    `${URI_FINANCIAL_ACCOUNT}labels/${labelId}`,
    opts,
  );
  const jsonResult = await response.json();

  if (response.status >= 400) {
    return Promise.reject(jsonResult.message);
  }
  return jsonResult.data;
};
